/**
 * Large number + label + optional trend arrow.
 */

import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import type { Trend } from "@/lib/chart-helpers";
import { cn } from "@/lib/utils";

type MetricDisplayProps = {
  label: string;
  value: string;
  trend?: Trend;
  className?: string;
};

const trendIcons: Record<Trend, typeof TrendingUp> = {
  up: TrendingUp,
  down: TrendingDown,
  flat: Minus,
};

const trendColors: Record<Trend, string> = {
  up: "text-green-500",
  down: "text-red-500",
  flat: "text-muted-foreground",
};

export function MetricDisplay({ label, value, trend, className }: MetricDisplayProps) {
  const Icon = trend ? trendIcons[trend] : null;

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
      <div className="flex items-center gap-2">
        <span className="text-2xl font-bold tracking-tight">{value}</span>
        {Icon && trend && <Icon className={cn("h-4 w-4", trendColors[trend])} />}
      </div>
    </div>
  );
}
